var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1767862397072,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1709,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M944 896a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h864zM507.392 143.424a64 64 0 0 1 78.336-45.248l40.512 10.88a64 64 0 0 1 47.104 55.296l31.104 302.848a16 16 0 0 0 11.776 13.824l122.56 32.832a128 128 0 1 1-66.24 247.296l-587.328-157.44A128 128 0 0 1 94.72 447.04l53.824-200.896a64 64 0 0 1 78.4-45.248l41.728 11.2a64 64 0 0 1 46.72 51.84l16.384 104.32a16 16 0 0 0 11.712 12.928l78.016 20.928a16 16 0 0 0 19.584-11.328l66.24-247.296z m77.248 20.736a16 16 0 0 0-19.584 11.328L498.752 422.72a64 64 0 0 1-78.336 45.312L316.8 440.256a64 64 0 0 1-46.72-51.84l-16.384-104.32a16 16 0 0 0-11.648-12.928l-16.256-4.352a16 16 0 0 0-19.584 11.264l-49.728 185.472a64 64 0 0 0 45.248 78.4l587.328 157.376a64 64 0 1 0 33.088-123.648l-133.248-35.712a64 64 0 0 1-47.104-55.296l-31.04-302.848a16 16 0 0 0-11.776-13.824l-14.4-3.84z",
    fill: "#ffffff",
    "p-id": 1710
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIn);
export default __webpack_public_path__ + "static/media/shipIn.15f711a199dbfa74cb139d7d54c8c4e3.svg";
export { ForwardRef as ReactComponent };